import {Directive, ElementRef, Host, Optional, Self} from '@angular/core';
import {DxChartComponent, DxPieChartComponent, DxPolarChartComponent} from 'devextreme-angular';

@Directive({
    selector: '[dDxRedrawOnElementResize]',
    standalone: false
})
export class RedrawDxWidgetOnElementResizeDirective {

	constructor(
		@Host() @Self() @Optional() private _dxChartComponent: DxChartComponent,
		@Host() @Self() @Optional() private _dxPieChartComponent: DxPieChartComponent,
		@Host() @Self() @Optional() private _dxPolarChartComponent: DxPolarChartComponent,
		private _elementRef: ElementRef,
	) {
		const resizeObserver: ResizeObserver = new ResizeObserver(
			(entries: ResizeObserverEntry[], observer: ResizeObserver): void => {
				
				if (this._dxChartComponent) {
					this._dxChartComponent.instance.render();
				} else if (this._dxPieChartComponent) {
					this._dxPieChartComponent.instance.render();
				} else if (this._dxPolarChartComponent) {
					this._dxPolarChartComponent.instance.render();
				}
			}
		);

		resizeObserver.observe(this._elementRef.nativeElement);
	}
}